module.exports = __webpack_public_path__ + "img/en.f93f5b6f.png";